import { fetchAllStudents, fetchSessionsStudents } from '@/services/students'
import type { Evaluation, Session, Student } from '@/types/global'
import { useQuery } from '@tanstack/vue-query'
import type { ComputedRef, Ref } from 'vue'
import { allSessions } from './sessions'
import { filterCurrentStudentSessionEvaluations } from '@/utils/currentSessionEvaluations'

export const useStudents = (
  sessions: Ref<Session[] | undefined>,
  evaluations: Ref<{ [key: number]: Evaluation[] } | undefined>,
  enabled: ComputedRef<boolean>
) =>
  useQuery({
    queryKey: ['students', evaluations, sessions],
    queryFn: async () => {
      if (!sessions.value) return []
      const result = await fetchSessionsStudents(sessions.value)

      for (const session of sessions.value) {
        for (const student of result[session.id]) {
          student.evaluations = filterCurrentStudentSessionEvaluations(
            student,
            evaluations.value?.[session.id]?.filter?.((e) => e.student_id.id == student.id)
          )
        }
      }

      return result
    },
    enabled
  })

export const allStudents = (fields?: string[], filters: [string, string, any][] = []) => {
  return useQuery({
    queryKey: ['students'],
    queryFn: async () => await fetchAllStudents(filters, fields)
  })
}
